interface CategoryTabsProps {
  activeCategory: string
  onCategoryChange: (category: string) => void
  counts?: Record<string, number>
}

const CATEGORIES = [
  { value: 'all', label: 'Tous' },
  { value: 'flyers', label: 'Flyers' },
  { value: 'programme', label: 'Programme' },
  { value: 'communiques', label: 'Communiqués' },
  { value: 'autres', label: 'Autres' },
]

function CategoryTabs({ activeCategory, onCategoryChange, counts }: CategoryTabsProps) {
  return (
    <div className="category-tabs">
      {CATEGORIES.map((cat) => (
        <button
          key={cat.value}
          className={`category-tab ${activeCategory === cat.value ? 'active' : ''}`}
          onClick={() => onCategoryChange(cat.value)}
        >
          {cat.label}
          {counts && counts[cat.value] !== undefined && (
            <span className="count">({counts[cat.value]})</span>
          )}
        </button>
      ))}
    </div>
  )
}

export default CategoryTabs
